import React, { useState } from 'react';
import Header from '../../components/Header';
import Navbar from '../../components/Navbar';
import HowItWork from '../../components/HowItWork';
import FAQSection from '../../components/FAQSection';
import Footer from '../../components/Footer';
import FormSection from '../../components/FormSection';
import UseExpertsServices from '../../components/UseExpertsServices';
import OrderPricingButtons from '../../components/OrderPricingButtons';

const Index = () => {
  const [forceResetForm, setForceResetForm] = useState(false);
  const ifFormEnabled = false;

  return (
    <div className="home-page">
      {!ifFormEnabled && (
        <div className="modal-container">
          <div className="modal">
            <p>
              Szanowni Państwo,<br />

              dziękujemy za kontakt oraz zainteresowanie usługami DEKRA.<br />

              Ze względu na okres wakacyjny oraz ograniczoną dostępność ekspertów do dnia 31 sierpnia 2026 r. zawieszamy przyjmowanie i realizację jednorazowych zleceń koncentrując nasze zasoby na obsłudze umów o stałej współpracy.<br />

              Przepraszamy za utrudnienia i dziękujemy za wyrozumiałość.<br />

              DEKRA Polska<br />
            </p>
          </div>
        </div>
      )}
      <Navbar />
      <Header />
      <UseExpertsServices />
      <OrderPricingButtons setForceResetForm={setForceResetForm} />
      <HowItWork />
      <FAQSection />
      <FormSection forceResetForm={forceResetForm} setForceResetForm={setForceResetForm} ifFormEnabled={ifFormEnabled} />
      <Footer />
    </div>
  );
};

export default Index;
